<template>
  <div class="add">
    <div>
      <div class="textarea_box">
        <van-field
          v-model="formData.content"
          label=""
          maxlength="900"
          placeholder="回答：请输入内容"
          rows="10"
          show-word-limit
          type="textarea"
        />
      </div>

      <div class="resources-box" style="margin-bottom: -6px; padding: 0 16px">
        <div>
          <zy-uploader
            v-model:file="formData.Image"
            :limit-size="500 * 1024"
            :max-count="9"
            :max-size="10 * 1024 * 1024"
          />
          <div style="font-size: 12px; color: #999; margin: -5px 0 10px">
            上传10M以内图片
          </div>
        </div>
        <div>
          <zy-video-uploader
            v-model:file="formData.Video"
            :max-count="9"
            :max-size="400 * 1024 * 1024"
          />
          <div style="font-size: 12px; color: #999; margin: -5px 0 10px">
            上传400M以内视频
          </div>
        </div>
        <div>
          <zy-audio-uploader
            v-model:file="formData.Audio"
            :max-count="9"
            :max-size="400 * 1024 * 1024"
          />
          <div style="font-size: 12px; color: #999; margin: -5px 0 10px">
            上传400M以内音频
          </div>
        </div>
        <div>
          <zy-file-uploader
            v-model:file="formData.File"
            :max-count="9"
            :max-size="100 * 1024 * 1024"
          />
          <div style="font-size: 12px; color: #999; margin: -5px 0 10px">
            上传100M以内文件
          </div>
        </div>
      </div>
    </div>
    <div class="btn-box flex fixed">
      <div class="cancel">
        <van-button
          block
          color="#b57e48"
          plain
          round
          type="primary"
          @click="cancel"
        >
          取消
        </van-button>
      </div>
      <div class="flex-1">
        <van-button
          block
          color="#b57e48"
          :loading="submitLoading"
          round
          type="primary"
          @click="submit"
        >
          提交作业
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
  import { nextTick, ref } from 'vue'
  import ZyUploader from '@/components/ZyUploader'
  import ZyFileUploader from '@/components/ZyFileUploader'
  import ZyVideoUploader from '@/components/ZyVideoUploader'
  import ZyAudioUploader from '@/components/ZyAudioUploader' //音频上传
  import store from '@/store'
  import { useRouter, useRoute } from 'vue-router'
  import { router, watch, onMounted, onBeforeUnmount } from 'vue'
  import { Toast, Dialog } from 'vant'
  import storage from '@/utils/storage'
  export default {
    components: {
      ZyUploader,
      ZyVideoUploader,
      ZyAudioUploader,
      ZyFileUploader,
    },
    props: {
      homework: {
        type: Object,
        default: () => {},
      },
    },
    emits: ['cenal', 'cenalTj'],
    setup(props, ctx) {
      const showTopic = ref(false)
      const active = ref(1)
      const loading = ref(true)
      const topicList = ref([])
      const router = useRouter()
      const route = useRoute()
      const formData = ref({
        deliveryId: null,
        content: '',
        deliveryFiles: [],
        Image: [],
        Video: [],
        Audio: [],
        File: [],
      })
      const submitLoading = ref(false)
      const isInit = ref(false)

      onMounted(() => {
        console.log('onMounted', isInit.value)
        formData.value.deliveryId = props.homework.DeliveryId
        formData.value.content = props.homework.Content

        formData.value.deliveryFiles = props.deliveryfiles
        formData.value.Video = props.homework.Video
        formData.value.Image = props.homework.Image
        formData.value.File = props.homework.File
        formData.value.Audio = props.homework.Audio

        console.log('formData', props)
        nextTick(() => {
          isInit.value = true
          initStorage()
        })
      })

      // 作业添加缓存
      watch(
        formData,
        (val) => {
          if (isInit.value) {
            setStorage(val)
          }
        },
        { deep: true }
      )
      const setStorage = (val) => {
        storage.set(`homework-v2-${val.deliveryId}`, JSON.stringify(val))
      }
      const getStorage = (val) => {
        const res = storage.get(`homework-v2-${val.deliveryId}`)
        return res ? JSON.parse(res) : res
      }
      const removeStorage = (val) => {
        storage.remove(`homework-v2-${val.deliveryId}`)
      }
      const initStorage = () => {
        const data = getStorage(formData.value)
        if (data) {
          Dialog.confirm({
            title: '温馨提示',
            message: `存在缓存内容，是否加载内容继续填写`,
            confirmButtonText: '继续填写',
            cancelButtonText: '不加载',
          })
            .then(() => {
              Object.assign(formData.value, data)
            })
            .catch(() => {
              // 只有在发布完成后才真正的清除内容
              //removeStorage(formData.value)
            })
        }
      }

      // const getImgList = (val) => {
      //   formData.value.deliveryFiles = []
      //   if (!val[0].deliveryName) {
      //     formData.value.deliveryFiles = props.deliveryfiles
      //   } else {
      //     formData.value.deliveryFiles = val
      //   }
      // }

      const cancel = () => {
        ctx.emit('cenal')
      }
      const submit = async () => {
        // if (props.deliverytype === 50) {
        //   if (!formData.value.content) {
        //     Toast('请输入内容!')
        //     return
        //   }
        // }
        // if (props.deliverytype < 50) {
        //   if (!formData.value.deliveryFiles.length) {
        //     Toast('请上传内容!')
        //     return
        //   }
        // }

        console.log(formData.value)

        if (
          !formData.value.content &&
          !formData.value.Image.length &&
          !formData.value.Video.length &&
          !formData.value.File.length &&
          !formData.value.Audio.length
        ) {
          Toast('请输入或上传内容!')
          return
        }

        SubmitHomework()
      }

      const SubmitHomework = (id) => {
        const params = formData.value
        params.formId = route.params.id
        store
          .dispatch('service/SubmitHomework', params)
          .then((data) => {
            //console.log('data :>> ', data)
            if (data.Code === 0) {
              Toast('发布成功')
              setTimeout(() => {
                removeStorage(params)
                ctx.emit('cenalTj', params)
              }, 500)
            } else {
              Toast.fail(data.message)
            }
          })
          .catch((e) => {
            //console.log('e :>> ', e)
            Toast.fail(e.Message || '发布失败')
          })
      }
      return {
        showTopic,
        active,
        loading,
        topicList,
        cancel,
        submit,
        submitLoading,
        // getImgList,
        formData,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .ts {
    font-size: 12px;
    color: #ccc;
  }
  .add {
    background: #fff;
    padding: 10px 0 90px;
    // min-height: 100vh;
    box-sizing: border-box;
    //height: 100vh;
    //padding-top: 48px;
  }
  .btn-list {
    li {
      text-align: center;
      line-height: 1;
      color: #666;
      padding: 0 8px;
      margin-right: 10px;
      i {
        font-size: 24px;
      }
      p {
        color: #333;
        font-size: 14px;
        margin: 6px 0 0;
      }
      &.current {
        color: #1989fa;
        p {
          color: #1989fa;
        }
      }
    }
  }
  .btn-box {
    background: #fff;
    padding: 16px;
    .cancel {
      width: 26%;
      padding-right: 10px;
    }
    &.fixed {
      position: fixed;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1024;
    }
  }
  .topic-content {
    //min-height: 200px;
    .content ul {
      padding: 20px 20px;
      li {
        margin: 10px 16px;
        a {
          color: #666;
          &.current {
            color: #1989fa;
          }
        }
      }
    }
    .btn-box {
      padding: 10px 16px;
    }
  }
  .loading-box {
    text-align: center;
    padding: 50px;
  }
  .resources-box {
    div + div {
      margin: 10px 0 0;
    }
  }
  .no-data {
    padding-bottom: 10px;
    color: #666;
    font-size: 14px;
  }
  .edit {
    &:empty:before {
      content: '请输入正文';
      color: #ccc;
    }
    &:focus:before {
      content: none;
    }
  }
  .van-field__body .van-field__control {
    border: 1px solid #eee !important;
  }
  .textarea_box {
    padding: 16px;
    border-radius: 3px;
    > div {
      border: 1px solid #e1e1e1;
    }
  }
</style>
